import { ViewType } from '@/domains/base/enums/view-type';
import _ from 'lodash';
/** view type for api */
export const PATENT_VIEW_TYPE_MAP = {
    [ViewType.TABLE]: 'tablelist',
    [ViewType.STANDARD]: 'standardlist',
    [ViewType.FULL_IMAGE]: 'pdfimage',
    [ViewType.THUMB]: 'thumbnail',
    [ViewType.FAST_TABLE]: 'fasttablelist',
    [ViewType.WORD_CLOUD]: 'wordcloud',
};
/**
 * view type for legacy
*/
export const LEGACY_VIEW_TYPE_MAP = {
    [ViewType.TABLE]: 'folders',
    [ViewType.STANDARD]: 'images',
    [ViewType.FULL_IMAGE]: 'fullimgs',
    [ViewType.THUMB]: 'thumbs',
    [ViewType.WORD_CLOUD]: 'wordcloud',
    [ViewType.FAST_TABLE]: 'fasttablelist',
};
/**
 * 反转 LEGACY_VIEW_TYPE_MAP
 * @description 兼容老路由
 */
export const LEGACY_VIEW_TYPE_MAP_REVERSE = _.invert(LEGACY_VIEW_TYPE_MAP);
